import axios from '@fs/zion-axios'
import SERVICE from './serviceName'

const BASE = `${SERVICE}/place/ws/places/request`

export const getPlaces = async (params) => {
  return axios.get(`${BASE}`, { params })
}
